module.exports = __webpack_public_path__ + "img/help5_mobile.36b35435.png";